import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { catchError } from "rxjs/operators";
import { HandleHttpError } from 'src/app/core/utils/HttpHandleError';
@Injectable()
export class NeoOperadorDatosService {
  public url: string;

  constructor(private _http: HttpClient) {
    this.url = environment.apiLocalUrl + 'neoOperadorDatos/';
  }

  getFindById(idIntermediarioFinanciero){
    return this._http.get(`${this.url}` + idIntermediarioFinanciero).pipe(catchError(HandleHttpError));
  }

  getAll() : Observable<any>{
    return this._http.get(this.url).pipe(catchError(HandleHttpError));
  }

}
